import { rootMenuList } from "./root-menu-list";

export function rootArrayMenu(root:any,rootMenus:any){
    //$('.dropdown.menu-large a[data-title='+root.name+']').parent().remove();
    $('.dropdown.menu-large a[href="'+root.link+'"]').parent().remove();
    rootMenus.push(rootMenuList(root));
}